<script setup>
/* eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text */
import { h } from 'vue';
import { useVueTable, getCoreRowModel } from '@tanstack/vue-table';
import Table from 'dashboard/components/table/Table.vue';
import Button from 'dashboard/components-next/button/Button.vue';
import { money, kinds } from './model';
const props = defineProps({
  rows: { type: Array, default: () => [] },
  disabled: Boolean,
});
const emit = defineEmits(['details']);
const groupText = row =>
  (row.allocations || []).map(a => a.title).join('; ') ||
  'Движение между счетами';
const columns = [
  {
    accessorKey: 'occurred_on',
    header: 'Дата',
    cell: ({ row }) => row.original.occurred_on || 'Не указана',
  },
  {
    id: 'description',
    size: 280,
    header: 'Операция',
    cell: ({ row }) =>
      h(Button, {
        label: row.original.description,
        slate: true,
        ghost: true,
        disabled: props.disabled,
        class:
          'max-w-full w-full min-w-0 text-left [&>span]:whitespace-normal [&>span]:break-words',
        onClick: () => emit('details', row.original),
      }),
  },
  {
    id: 'kind',
    header: 'Тип / категория',
    cell: ({ row }) => `${kinds[row.original.kind]} · ${row.original.category}`,
  },
  {
    id: 'groups',
    size: 260,
    header: 'Группы',
    cell: ({ row }) =>
      h('span', { class: 'text-sm break-words' }, groupText(row.original)),
  },
  {
    id: 'amount',
    header: 'Сумма в выборке',
    cell: ({ row }) =>
      money(row.original.selected_amount_minor, row.original.currency),
  },
];
const table = useVueTable({
  get data() {
    return props.rows;
  },
  columns,
  getCoreRowModel: getCoreRowModel(),
  enableSorting: false,
});
</script>

<template>
  <div class="hidden lg:block overflow-x-auto">
    <Table :table="table" fixed type="compact" class="w-full min-w-[800px]" />
  </div>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:hidden gap-3">
    <article
      v-for="row in rows"
      :key="row.id"
      class="p-4 border border-n-weak rounded-xl min-w-0 flex flex-col gap-2"
    >
      <Button
        :label="row.description"
        slate
        ghost
        class="max-w-full w-full min-w-0 text-left justify-start [&>span]:whitespace-normal [&>span]:break-words"
        :disabled="disabled"
        @click="emit('details', row)"
      />
      <p class="text-sm text-n-slate-11 m-0">
        {{ row.occurred_on || 'Дата не указана' }} · {{ kinds[row.kind] }}
      </p>
      <p class="text-sm text-n-slate-12 m-0 break-words">
        {{ groupText(row) }}
      </p>
      <p class="text-sm font-medium text-n-slate-12 m-0">
        {{ money(row.selected_amount_minor, row.currency) }}
      </p>
      <p v-if="row.source_changed" class="text-sm text-n-amber-11 m-0">
        Источник изменился — нужна сверка
      </p>
    </article>
  </div>
</template>
